<template>
  <div v-if="video" class="aspect-w-16 aspect-h-9">
    <video
      class="w-full rounded-md"
      autoplay
      controls
      controlsList="nodownload"
      playsinline
      :data-poster="video.poster ? '' : ''"
    >
      <source
        :src="
          video.videoUrl
            ? `${backendUrl}${video.videoUrl}`
            : '/video/video1.mp4'
        "
        type="video/mp4"
      />
    </video>
  </div>
  <div v-else class="aspect-w-16 aspect-h-9 bg-primary rounded-md"></div>
  <!-- </vue-plyr> -->
</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  mounted() {
    if (this.video) {
      console.log('videoPlayer', this.video)
    }
  },
}
</script>

<style lang="scss">
.plyr {
  &__control {
    &--overlaid {
      background: var(--kit-color-primary);
    }
  }
  &__controls {
    &__item {
      .plyr__control {
        &:hover {
          background: var(--kit-color-primary);
        }
      }
    }
    &__item.plyr__control {
      &:hover {
        background: var(--kit-color-primary);
      }
    }
    &__item.plyr__progress__container {
      .plyr__progress {
        input[type="range"] {
          color: var(--kit-color-primary);
        }
        // background: red;
      }
    }
    &__item.plyr__volume {
      input[type="range"] {
        color: var(--kit-color-primary);
      }
    }
  }
}
</style>
